import moment from "moment";
import { BaseEntity, MemoizeGetters } from "./base";


@MemoizeGetters
export class CreditCard extends BaseEntity{
  brand: string;
  last4: string;
}